import React from 'react';
import PropTypes from 'prop-types';

import Modal from '@deliveroo/consumer-component-library/components/Modal';
import Heading from '@deliveroo/consumer-component-library/components/Heading';
import Button from '@deliveroo/consumer-component-library/components/Button';
import P from '@deliveroo/consumer-component-library/components/P';
import i18n from '../../utils/i18n';

const Dialog = ({ isOpen, headerTitle, message, onClose }) => (
  <Modal
    appElement="#__next"
    type="dialog"
    isOpen={isOpen}
    onClose={onClose}
    closeButtonLabel={i18n.gettext('closeButton.label')}
    renderFooter={() => (
      <Button type="primary" onClick={onClose} isBlock>
        {i18n.gettext('Ok')}
      </Button>
    )}
  >
    <Heading level={2}>{headerTitle}</Heading>
    <P spacing="medium 0 0 0">{message}</P>
  </Modal>
);

Dialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  headerTitle: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Dialog;
